  var pathname = window.location.pathname;
  var url_key = pathname.replace('/collections/', '');
  var scrollPosition;
  var STORAGE_KEY = 'scrollY-'+url_key;

  if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

// $(document).ready(function () {
//   // ブラウザバックの時のみ
//     if (window.performance.navigation.type == 2) {

//       scrollPosition = localStorage.getItem(STORAGE_KEY);
//       if(scrollPosition !== null){
//           scrollTo(0, scrollPosition);
//           console.log('スクロール量を変更：'+scrollPosition)
//       }
        
//     }
// }); 

// // スクロール位置を保存する関数
// function saveScrollPosition(){
//   scrollPosition = $(window).scrollTop(); 
//   localStorage.setItem(STORAGE_KEY, scrollPosition);
// }

// // スクロールしたら関数を挙動
// $(window).on('scroll', function(){
//   saveScrollPosition()
// });


// Cookie
$(document).ready(function () {
  if (window.performance.navigation.type == 2) {
    scrollPosition = $.cookie(STORAGE_KEY);
    if(scrollPosition !== null){
      scrollTo(0, scrollPosition);
      console.log('cookieだよ：'+scrollPosition)
    }
  }
});

$(window).on('scroll', function(){
  scrollPosition = $(window).scrollTop(); 
  $.cookie(STORAGE_KEY, scrollPosition);
});


